import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button from '../../../Button';
import AddIcon from '@wix/da-ds/pkg/Icons/Add';
import PlusIconWithTextButton from '../PlusIconWithTextButton';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import submitDeviationsButtonStyles from './SubmitDeviationsButton.scss';
const enhance = compose(withCurrentGallection);
export const SubmitDeviationsButton = ({ buttonView , plusOnly , currentFolderId  })=>{
    const { t  } = useTranslation();
    return plusOnly ? /*#__PURE__*/ React.createElement(Button, {
        view: 'b3',
        href: `${URLS.SUBMIT}?folderid=${currentFolderId}`,
        className: submitDeviationsButtonStyles['add-button']
    }, /*#__PURE__*/ React.createElement(AddIcon, {
        className: submitDeviationsButtonStyles['add-icon']
    })) : /*#__PURE__*/ React.createElement(PlusIconWithTextButton, {
        buttonView: buttonView,
        href: `${URLS.SUBMIT}?folderid=${currentFolderId}`,
        text: t('mediapopup.submitDeviations')
    });
};
SubmitDeviationsButton.displayName = 'SubmitDeviationsButton';
export default enhance(SubmitDeviationsButton);
